<section class="widget">
  <div class="widget-head">
    <h2>{{ title }}</h2>
  </div>
  <div class="explanation">
    <strong>How to use this widget</strong>
    <p>
      Evaluation pipelines run weekly every Monday in production. Enter the
      scheduled Monday run date (YYYY-MM-DD) that identifies a completed
      evaluation run, optionally select a group or metric, and click
      <b>Load results</b>. Scores are colour-coded: green is 70% or higher,
      amber is 50–69%, and red is below 50%.
    </p>
  </div>
  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Weekly run date (YYYY-MM-DD)</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="runDate"
        matTooltip="Evaluation batch jobs execute every Monday (e.g. 2026-09-07). Enter the date to query results."
        (ngModelChange)="runDateChange.emit($event)"
        [placeholder]="placeholder"
      />
    </mat-form-field>
    <mat-form-field appearance="outline"
      ><mat-label>Group</mat-label
      ><mat-select
        [(ngModel)]="group"
        (ngModelChange)="groupChange.emit($event)"
        ><mat-option value="">All groups</mat-option>
        @for (item of groups; track item) {
          <mat-option [value]="item">{{ item }}</mat-option>
        }
      </mat-select></mat-form-field
    ><mat-form-field appearance="outline"
      ><mat-label>Metric</mat-label
      ><mat-select
        [(ngModel)]="metric"
        (ngModelChange)="metricChange.emit($event)"
        ><mat-option value="">All metrics</mat-option>
        @for (item of metrics; track item) {
          <mat-option [value]="item">{{ item }}</mat-option>
        }
      </mat-select></mat-form-field
    ><button
      mat-flat-button
      color="primary"
      (click)="loadResults.emit()"
      [disabled]="!runDate || loading"
    >
      Load results</button
    ><button mat-stroked-button (click)="clear.emit()" [disabled]="loading">
      Clear filters
    </button>
  </div>
  @if (!runDate) {
    <p class="hint">
      Enter a scheduled Monday run date (e.g. 2026-09-07) or select a run from
      the list above to view quality metrics.
    </p>
  }
  @if (loading) {
    <app-loading-state></app-loading-state>
  } @else if (error) {
    <app-error-state [message]="error"></app-error-state>
  } @else if (runDate) {
    @if (results.length) {
      <div class="summary">
        <div>
          <small>Total results</small><strong>{{ results.length }}</strong>
        </div>
        <div>
          <small>Average score</small
          ><strong>{{ average() | percent: '1.0-1' }}</strong>
        </div>
        <div>
          <small>Highest scoring metric</small
          ><strong
            >{{ highest()?.metricName || '—' }}
            @if (highest()) {
              <em>{{ highest()!.score | percent: '1.0-1' }}</em>
            }
          </strong>
        </div>
        <div>
          <small>Lowest scoring metric</small
          ><strong
            >{{ lowest()?.metricName || '—' }}
            @if (lowest()) {
              <em>{{ lowest()!.score | percent: '1.0-1' }}</em>
            }
          </strong>
        </div>
      </div>
    } @else {
      <app-empty-state
        message="No evaluation results were found."
      ></app-empty-state>
    }
    <app-evaluation-score-histogram
      [results]="results"
    ></app-evaluation-score-histogram>
    @if (metricScores().length) {
      <section class="metric-histogram">
        <div>
          <h3>Average score by metric</h3>
          <p>Quickly compare the quality areas that need the most attention.</p>
        </div>
        <div class="metric-bars">
          @for (item of metricScores(); track item.metric) {
            <div class="metric-bar">
              <div class="metric-label">
                <span>{{ item.metric }}</span>
                <strong>{{ item.average | percent: '1.0-1' }}</strong>
              </div>
              <div
                class="bar-track"
                [attr.aria-label]="
                  item.metric + ': ' + (item.average | percent: '1.0-1')
                "
              >
                <div
                  class="bar-fill"
                  [class.good]="item.average >= 0.7"
                  [class.warn]="item.average >= 0.5 && item.average < 0.7"
                  [class.bad]="item.average < 0.5"
                  [style.width.%]="item.average * 100"
                ></div>
              </div>
              <small
                >{{ item.count }}
                {{ item.count === 1 ? 'result' : 'results' }}</small
              >
            </div>
          }
        </div>
      </section>
    }
  }
</section>
